import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { User } from "@/types/types";
import { ApiService } from "@/services/api-service";

type AuthToken = {
  token: string | null;
  refreshToken?: string | null;
};

interface AuthStore {
  isLoggedIn: boolean;
  user: User | null;
  login: (user: User, token: AuthToken) => void;
  authTokens: AuthToken | null;
  logout: () => void;
  updateUser: (data: Partial<User>) => void;
}

const useAuthStore = create(
  persist<AuthStore>(
    (set) => ({
      isLoggedIn: false,
      user: null,
      login: (user, tokens) => {
        set({
          isLoggedIn: true,
          user,
          authTokens: tokens,
        });
      },
      authTokens: {
        token: "",
        refreshToken: "",
      },
      updateUser: (data: Partial<User>) =>
        set((state) => {
          if (!state.user) return {};
          return {
            user: {
              ...state.user,
              ...data,
              user_profile: {
                ...state.user.user_profile,
                ...data.user_profile,
              },
            },
          };
        }),

      token: null,
      logout: async () => {
        await ApiService.logout();
        set({ isLoggedIn: false, user: null, authTokens: null });
      },
    }),
    {
      name: "auth-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export const useUser = () => useAuthStore((state) => state.user);
export const useIsLoggedIn = () => useAuthStore((state) => state.isLoggedIn);
export const getAuthTokens = () => useAuthStore.getState().authTokens;

export const useAuthStoreActions = () => ({});

// TODO: remove export of this
export default useAuthStore;
